import { z } from 'zod';
import { FailureDiagnosticEvidenceSchema } from './issue-evidence.js';
import { IssueSeveritySchema } from './issue-core.js';
import {
  DIAGNOSTIC_LIMIT,
  TITLE_LIMIT,
  URL_LIMIT,
  UUID,
  optionalCategoryKey,
  optionalLimitedString,
  optionalSafeUrl,
  requiredLimitedString,
} from './issues-schema-utils.js';

const ManualEvidenceInput = z
  .array(FailureDiagnosticEvidenceSchema)
  .max(50, 'At most 50 evidence items may be attached')
  .optional()
  .nullable()
  .transform((value) => value ?? null);

const OptionalUuid = UUID.optional()
  .nullable()
  .transform((value) => value ?? null);

const ManualOccurrenceFields = {
  body: optionalLimitedString(DIAGNOSTIC_LIMIT),
  primaryUrl: optionalSafeUrl(URL_LIMIT),
  runId: OptionalUuid,
  evidence: ManualEvidenceInput,
};

export const CreateManualIssuePayloadSchema = z.object({
  propertyId: UUID,
  issueTitle: requiredLimitedString('Issue title', TITLE_LIMIT),
  issueSeverity: IssueSeveritySchema,
  issueCategoryId: OptionalUuid,
  issueCategoryKey: optionalCategoryKey,
  ...ManualOccurrenceFields,
});
export type CreateManualIssuePayload = z.infer<typeof CreateManualIssuePayloadSchema>;

export const AddIssueOccurrencePayloadSchema = z.object({
  ...ManualOccurrenceFields,
});
export type AddIssueOccurrencePayload = z.infer<typeof AddIssueOccurrencePayloadSchema>;
